import { render, staticRenderFns } from "./DocTable.vue?vue&type=template&id=c041466c&scoped=true&"
import script from "./doctable.js?vue&type=script&lang=js&"
export * from "./doctable.js?vue&type=script&lang=js&"
import style0 from "./DocTable.vue?vue&type=style&index=0&id=c041466c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c041466c",
  null
  
)

export default component.exports